/** @format */

import React from "react";
import ChangePasswordPage from "../components/change-password/changePasswordPage";
import LoginPage from "../pages/login/LoginPage";
import RegistrationPageNew from "../components/registration/RegistrationPageNew";
import PrivacyPolicyPage from "../components/documents/PrivacyPolicyPage";
import TermsUsePage from "../components/documents/TermsUsePage";
import NewPasswordPage from "../components/forgot-password/NewPasswordPage";
import ConfirmEmailPage from "../components/confirm-email/ConfirmEmail";
import OrdersList from "../pages/orders/list";
import RailwayOrdersListPage from "../pages/orders/list/RailwayOrdersListPage";
import { RAILWAY_ORDERS_PATH, RAILWAY_EXPEDITOR_ORDERS_PATH } from "../pages/orders/utils/railwayOrder";
import RailwayOrdersAvailablePage from "../pages/orders/available/RailwayOrdersAvailablePage";
import ProfilePageComponentTwo from "../components/profileTwo/ProfilePageComponentTwo";
import BalanceLists from "../pages/balance/list";
import PageInDevelopPage from "../pages/page-in-develop";
import VerifyDocs from "../pages/verify-docs";
import Layouts from "../layouts";
import OrdersAvailable from "../pages/orders/available";
import OrdersDraftList from "../pages/orders/list-draft";
import Drivers from "../pages/drivers";
import DriversCreate from "../pages/drivers/create";
import CarsPage from "../pages/cars";
import CarsCreatePage from "../pages/cars/create";
import Index from "../pages/develop/IconsPage";
import NotificationPage from "../pages/notification";
import WorkersPage from "../pages/workers";
import WorkersCreatePage from "../components/workers/create/WorkersCreatePage";
import ConfirmEmployeePage from "../components/workers/confirm-employee/ConfirmEmployee";
import WorkersEditPage from "../components/workers/edit/WorkersEditPage";
import ForgotPasswordPageNew from "../components/forgot-password-new/ForgotPasswordPageNew";
import OnboardingPage from "../pages/onboarding";
import AnalyticsPage from "../pages/analytics";
import OrderAnalyticsPage from "../pages/analytics-new/OrderAnalyticsPage";
import OrdersCreatePage from "../pages/orders/create";
import ExistingOrderPage from "../pages/orders/components/ExistingOrderPage";
import OrdersCreateComplexTenderPage from "../pages/orders/create-complex-tender";
import ComplexTenderEditPage from "../pages/orders/create-edit-complex-tender";
import PartnersPage from "../pages/partners";
import OnboardingExpeditorPage from "../pages/onboarding-expeditor";
import OrdersCopyPage from "../pages/orders/create-copy/OrdersCopyPage";
import OrdersAviationCreatePage from "../pages/orders/create-aviation";
import OrdersAviationCopyPage from "../pages/orders/create-copy-aviation/OrdersAviationCopyPage";
import OrdersAvailableAviationPage from "../pages/orders/available-aviation";
import ExpeditorOrdersCreatePage from "../pages/orders/create-expeditor";
import ListsAviationPage from "../pages/orders/list-aviation";
import ExpeditorOrdersCopyPage from "../pages/orders/create-copy-expeditor";
import OrderInfoBookingCardMobile from "../components/orders-new/order-info/OrderInfoBookingCardMobile";
import OrderInfoMobile from "../components/orders-new/order-info/OrderInfoMobile";
import OrderInfoAviationMobile from "../components/orders-aviation/order-info/OrderInfoAviationMobile";
import GuestOrderViewPage from "../pages/orders/share-order";
import RegistrationPageCN from "../components/registration/RegistrationPageCN";
import DriversInvite from "../pages/drivers/invite";
import MarketplacePage from "../pages/marketplace";
import OrderInfoAviationMobileMarketplace from "../components/orders-aviation/order-info/components/OrderInfoAviation/MarketplaceMobile";
import OrderInfoMobileMarketplace from "../components/orders-new/order-info/components/OrderInfoAvto/MarketplaceMobile";
import ShipperGuidePage from "../pages/guide/shipper/ShipperGuidePage";
import ExpeditorGuidePage from "../pages/guide/expeditor/ExpeditorGuidePage";
import OrdersEditPage from "../pages/orders/create-edit";
import ExpeditorOrdersEditPage from "../pages/orders/create-edit-expeditor";
import OrdersAviationEditPage from "../pages/orders/create-edit-aviation";
import BulkOrderCreatePage from "../pages/orders/bulk-create";

export const routes = [
  {
    name: "login",
    title: "Login page",
    Component: LoginPage,
    Layout: Layouts.Without,
    path: "/login",
  },
  {
    name: "registration",
    title: "Registration page",
    Component: RegistrationPageNew,
    Layout: Layouts.Without,
    path: "/registration",
  },
  {
    name: "registration",
    title: "Registration page",
    Component: RegistrationPageCN,
    Layout: Layouts.Without,
    path: "/registration-cn",
  },
  {
    name: "privacy-policy",
    title: "Privacy-policy page",
    Component: PrivacyPolicyPage,
    Layout: Layouts.Without,
    path: "/privacy-policy",
  },
  {
    name: "terms-of-use",
    title: "Terms of use page",
    Component: TermsUsePage,
    Layout: Layouts.Without,
    path: "/privacy",
  },
  {
    name: "forgot-password",
    title: "Forgot password page",
    Component: ForgotPasswordPageNew,
    Layout: Layouts.Without,
    path: "/forgot-password",
  },
  {
    name: "/auth/reset-password/:code",
    title: "Reset password code page",
    Component: NewPasswordPage,
    Layout: Layouts.Without,
    path: "/auth/reset-password/:code",
  },
  {
    name: "/auth/confirm-email/:code",
    title: "Confirm email page",
    Component: ConfirmEmailPage,
    Layout: Layouts.Without,
    path: "/auth/confirm-email/:code",
  },
  {
    name: "/auth/confirm-employee/:code",
    title: "Confirm employee code page",
    Component: ConfirmEmployeePage,
    Layout: Layouts.Without,
    path: "/auth/confirm-employee/:code",
  },
  {
    name: "guest-order-view",
    title: "Просмотр заказа по ссылке",
    Component: GuestOrderViewPage,
    Layout: Layouts.Without,
    path: "/order/share/:guestToken",
  },
  {
    name: "onboarding",
    title: "onboarding page",
    Component: OnboardingPage,
    Layout: Layouts.Main,
    Private: true,
    path: "/onboarding",
  },
  {
    name: "onboarding-expeditor",
    title: "onboarding for a expeditor page",
    Component: OnboardingExpeditorPage,
    Layout: Layouts.Main,
    Private: true,
    path: "/onboarding-expeditor",
  },
  {
    name: "main",
    title: "Orders page",
    Component: OrdersList,
    Layout: Layouts.Main,
    Private: true,
    path: "/main",
  },
  {
    name: "railway-orders-list",
    title: "Railway orders page",
    Component: RailwayOrdersListPage,
    Layout: Layouts.Main,
    Private: true,
    path: RAILWAY_ORDERS_PATH,
  },
  {
    name: 'info-order-id',
    title: 'Orders info page',
    Component: OrderInfoMobile,
    Layout: Layouts.Main,
    Private: true,
    path: '/info/order/:id'
  },
  {
    name: "orders-create",
    title: "Orders create page",
    Component: OrdersCreatePage,
    Layout: Layouts.Main,
    Private: true,
    path: "/orders/create",
  },
  {
    name: "railway-orders-create",
    title: "Railway order create page",
    Component: () => <OrdersCreatePage isRailway />,
    Layout: Layouts.Main,
    Private: true,
    path: "/orders/railway/create",
  },
  {
    name: "orders-create-complex-tender",
    title: "Orders create complex tender page",
    Component: OrdersCreatePage,
    Layout: Layouts.Main,
    Private: true,
    path: "/orders/complex-tender/create",
  },
  {
    name: "orders-complex-copy-id",
    title: "Order complex copy page",
    Component: OrdersCreateComplexTenderPage,
    Layout: Layouts.Main,
    Private: true,
    path: "/orders/complex-tender/copy/:id",
  },
  {
    name: "orders-complex-edit-id",
    title: "Order complex edit page",
    Component: ComplexTenderEditPage,
    Layout: Layouts.Main,
    Private: true,
    path: "/orders/complex-tender/edit/:id",
  },
  {
    name: "orders-bulk-create",
    title: "Bulk order create page",
    Component: BulkOrderCreatePage,
    Layout: Layouts.Main,
    Private: true,
    path: "/orders/bulk-create",
  },
  {
    name: "orders-create",
    title: "Orders create page",
    Component: OrdersAviationCreatePage,
    Layout: Layouts.Main,
    Private: true,
    path: "/aviation/create",
  },
  {
    name: 'search-order-id',
    title: 'Search order page',
    Component: OrderInfoBookingCardMobile,
    Layout: Layouts.Main,
    Private: true,
    path: '/search/order/:id'
  },
  {
    name: "orders-available",
    title: "Orders available page",
    Component: OrdersAvailable,
    Layout: Layouts.Main,
    Private: true,
    path: "/orders/available",
  },
  {
    name: "railway-orders-available",
    title: "Railway orders available page",
    Component: RailwayOrdersAvailablePage,
    Layout: Layouts.Main,
    Private: true,
    path: RAILWAY_EXPEDITOR_ORDERS_PATH,
  },
  {
    name: "orders-available",
    title: "Orders available page",
    Component: OrdersAvailableAviationPage,
    Layout: Layouts.Main,
    Private: true,
    path: "/orders-aviation/available",
  },
  {
    name: "orders-aviation-list",
    title: "Orders aviation page",
    Component: ListsAviationPage,
    Layout: Layouts.Main,
    Private: true,
    path: "/aviation/list",
  },
  {
    name: 'aviation-order-id',
    title: 'Aviation order page',
    Component: OrderInfoAviationMobile,
    Layout: Layouts.Main,
    Private: true,
    path: '/aviation/order/:id'
  },
  {
    name: "orders-draft",
    title: "Orders draft page",
    Component: OrdersDraftList,
    Layout: Layouts.Main,
    Private: true,
    path: "/orders/draft",
  },
  {
    name: "orders-draft-id",
    title: "Order draft detail page",
    Component: () => <ExistingOrderPage mode="draft" />,
    Layout: Layouts.Main,
    Private: true,
    path: "/orders/draft/:id/edit",
  },
  {
    name: "orders-copy-id",
    title: "Order copy page",
    Component: OrdersCopyPage,
    Layout: Layouts.Main,
    Private: true,
    path: "/orders/copy/:id",
  },
  {
    name: "railway-orders-copy-id",
    title: "Railway order copy page",
    Component: () => <ExistingOrderPage mode="copy" />,
    Layout: Layouts.Main,
    Private: true,
    path: "/orders/railway/copy/:id",
  },
  {
    name: "railway-orders-edit-id",
    title: "Railway order edit page",
    Component: () => <ExistingOrderPage mode="edit" />,
    Layout: Layouts.Main,
    Private: true,
    path: "/orders/railway/edit/:id",
  },
  {
    name: "orders-edit-id",
    title: "Order edit page",
    Component: OrdersEditPage,
    Layout: Layouts.Main,
    Private: true,
    path: "/orders/edit/:id",
  },
  {
    name: "expeditor-orders-create",
    title: "Expeditor orders create page",
    Component: ExpeditorOrdersCreatePage,
    Layout: Layouts.Main,
    Private: true,
    path: "/expeditor/orders/create",
  },
  {
    name: "orders-draft-id",
    title: "Order draft detail page",
    Component: ExpeditorOrdersCreatePage,
    Layout: Layouts.Main,
    Private: true,
    path: "/expeditor/orders/draft/:id/edit",
  },
  {
    name: "expeditor-orders-copy-id",
    title: "Expeditor orders copy page",
    Component: ExpeditorOrdersCopyPage,
    Layout: Layouts.Main,
    Private: true,
    path: "/expeditor/orders/copy/:id",
  },
  {
    name: "expeditor-orders-edit-id",
    title: "Expeditor orders edit page",
    Component: ExpeditorOrdersEditPage,
    Layout: Layouts.Main,
    Private: true,
    path: "/expeditor/orders/edit/:id",
  },
  {
    name: "avia-orders-copy-id",
    title: "Avia order copy page",
    Component: OrdersAviationCopyPage,
    Layout: Layouts.Main,
    Private: true,
    path: "/aviation/copy/:id",
  },
  {
    name: "avia-orders-edit-id",
    title: "Avia order edit page",
    Component: OrdersAviationEditPage,
    Layout: Layouts.Main,
    Private: true,
    path: "/aviation/edit/:id",
  },
  {
    name: "profile",
    title: "Profile page",
    Component: ProfilePageComponentTwo,
    Layout: Layouts.Main,
    Private: true,
    path: "/profile",
  },
  {
    name: "change-password",
    title: "Change password page",
    Component: ChangePasswordPage,
    Layout: Layouts.Main,
    Private: true,
    path: "/change-password",
  },
  {
    name: "drivers",
    title: "drivers page",
    Component: Drivers,
    Layout: Layouts.Main,
    Private: true,
    path: "/drivers",
  },
  {
    name: "drivers-create",
    title: "drivers create page",
    Component: DriversCreate,
    Layout: Layouts.Main,
    Private: true,
    path: "/drivers/create",
  },
  {
    name: "drivers-create",
    title: "drivers create page",
    Component: DriversInvite,
    Layout: Layouts.Main,
    Private: true,
    path: "/drivers/invite",
  },
  {
    name: "cars",
    title: "cars page",
    Component: CarsPage,
    Layout: Layouts.Main,
    Private: true,
    path: "/cars",
  },
  {
    name: "cars-create",
    title: "drivers create page",
    Component: CarsCreatePage,
    Layout: Layouts.Main,
    Private: true,
    path: "/cars/create",
  },
  {
    name: "balance/lists",
    title: "balance/lists page",
    Component: BalanceLists,
    Layout: Layouts.Main,
    Private: true,
    path: "/balance/lists",
  },
  {
    name: "history-order",
    title: "history-order page",
    Component: PageInDevelopPage,
    Layout: Layouts.Main,
    Private: true,
    path: "/history-order",
  },
  {
    name: "transport-companies",
    title: "transport-companies page",
    Component: PageInDevelopPage,
    Layout: Layouts.Main,
    Private: true,
    path: "/transport-companies",
  },
  {
    name: "directions",
    title: "directions page",
    Component: PageInDevelopPage,
    Layout: Layouts.Main,
    Private: true,
    path: "/directions",
  },
  // {
  //   name: "marketplace",
  //   title: "marketplace page",
  //   Component: MarketplacePage,
  //   Layout: Layouts.Main,
  //   Private: true,
  //   path: "/marketplace",
  // },
  {
    name: 'info-order-id',
    title: 'Orders info page',
    Component: OrderInfoAviationMobileMarketplace,
    Layout: Layouts.Main,
    Private: true,
    path: 'marketplace/aviation/order/:id'
  },
  {
    name: 'info-order-id',
    title: 'Orders info page',
    Component: OrderInfoMobileMarketplace,
    Layout: Layouts.Main,
    Private: true,
    path: 'marketplace/info/order/:id'
  },
  {
    name: "partners",
    title: "partners page",
    Component: PartnersPage,
    Layout: Layouts.Main,
    Private: true,
    path: "/partners",
  },
  {
    name: "workers",
    title: "workers page",
    Component: WorkersPage,
    Layout: Layouts.Main,
    Private: true,
    path: "/workers",
  },
  {
    name: "workers-create",
    title: "workers create page",
    Component: WorkersCreatePage,
    Layout: Layouts.Main,
    Private: true,
    path: "/workers/create",
  },
  {
    name: "workers-edit-id",
    title: "workers edit page",
    Component: WorkersEditPage,
    Layout: Layouts.Main,
    Private: true,
    path: "/workers/edit/:id",
  },
  {
    name: "document-flow",
    title: "document-flow page",
    Component: PageInDevelopPage,
    Layout: Layouts.Main,
    Private: true,
    path: "/document-flow",
  },
  {
    name: "analytics",
    title: "analytics page",
    Component: AnalyticsPage,
    Layout: Layouts.Main,
    Private: true,
    path: "/analytics",
  },
  {
    name: "analytics-new",
    title: "new analytics page",
    Component: OrderAnalyticsPage,
    Layout: Layouts.Main,
    Private: true,
    path: "/analytics-new",
  },
  {
    name: "verify-docs",
    title: "verify-docs page",
    Component: VerifyDocs,
    Layout: Layouts.Main,
    Private: true,
    path: "/verify-docs",
  },
  {
    name: "notification",
    title: "notification page",
    Component: NotificationPage,
    Layout: Layouts.Main,
    Private: true,
    path: "/notification",
  },
  {
    name: "support",
    title: "support page",
    Component: PageInDevelopPage,
    Layout: Layouts.Main,
    Private: true,
    path: "/support",
  },
  {
    name: "guide",
    title: "shipper guide",
    Component: ShipperGuidePage,
    Layout: Layouts.Without,
    path: "/guide/shipper",
  },
  {
    name: "guide-expeditor",
    title: "expeditor guide",
    Component: ExpeditorGuidePage,
    Layout: Layouts.Without,
    path: "/guide/expeditor",
  },
  {
    name: "icons",
    title: "icons page",
    Component: Index,
    Layout: Layouts.Main,
    path: "/develop/icons",
  },
];
